import { gql } from '@apollo/client';
import NOTIFICATION from '../fragments/NOTIFICATION';
const GET_ALL_NOTIFICATIONS = gql `
  query GetMyNotifications($page: Int!, $size: Int!) {
    getMyNotifications(page: $page, size: $size) {
      content {
        ...NotificationNodeFields
      }
      totalElements
      totalPages
      number
      size
    }
  }
  ${NOTIFICATION}
`;
export default GET_ALL_NOTIFICATIONS;
